import VesselEmissionAnalytics from "./VesselEmissionAnalytics";
import VesselEmissionOverview from "./VesselEmissionOverview";
import FuelEfficiency from "./FuelEfficiency";
import ShipLoadingStatus from "./ShipLoadingStatus";
import VesselStateTransition from "./VesselStateTransition";
import FuelConsumption from "./FuelConsumption";
import MEFuelConsumption from "./MEFuelConsumption";
import RemainingFuel from "./RemainingFuel";
import MainEnginePower from "./MainEnginePower";
import SFOCEfficiency from "./SFOCEfficiency";

import MEEnginePerformance from "./MEEnginePerformance";
import MESpeedConsumption from "./MESpeedConsumption";
import MESogDraft from "./MESogDraft";
import MEFuelOverTime from "./MEFuelOverTime";
import MESogLoad from "./MESogLoad";
import MEFuelMCR from "./MEFuelMCR";
import MERpmMcr from "./MERpmMcr";
import MEFuelRpm from "./MEFuelRpm";

import AEEngineData from "./AEEngineData";
import AEPowerData from "./AEPowerData";
import AEFuelConsumption from "./AEFuelConsumption";
import AESfocRpm from "./AESfocRpm";

import BoilerOverview from "./BoilerOverview";
import BoilerEmissionAnalytics from "./BoilerEmissionAnalytics";
import BoilerFuelConsumption from "./BoilerFuelConsumption";

import IncineratorOverview from "./IncineratorOverview";
import IncineratorEmissionAnalytics from "./IncineratorEmissionAnalytics";
import IncineratorFuelConsumption from "./IncineratorFuelConsumption";

import IggOverview from "./IggOverview";
import IggEmissionAnalytics from "./IggEmissionAnalytics";
import IggFuelConsumption from "./IggFuelConsumption";

const VesselReference = () => {
  return (
    <div className="p-6 bg-white rounded-xl shadow-sm border border-gray-200">
      <VesselEmissionAnalytics />
      <VesselEmissionOverview />
      <FuelEfficiency />
      <ShipLoadingStatus />
      <VesselStateTransition />
      <FuelConsumption />
      <MEFuelConsumption />
      <RemainingFuel />
      <MainEnginePower />
      <SFOCEfficiency />

      <MEEnginePerformance />
      <MESpeedConsumption />
      <MESogDraft />
      <MEFuelOverTime />
      <MESogLoad />
      <MEFuelMCR />
      <MERpmMcr />
      <MEFuelRpm />

      <AEEngineData />
      <AEPowerData />
      <AEFuelConsumption />
      <AESfocRpm />

      <BoilerOverview />
      <BoilerEmissionAnalytics />
      <BoilerFuelConsumption />

      <IncineratorOverview />
      <IncineratorEmissionAnalytics />
      <IncineratorFuelConsumption />

      <IggOverview />
      <IggEmissionAnalytics />
      <IggFuelConsumption />
    </div>
  );
};

export default VesselReference;